var k = Object.defineProperty, q = Object.defineProperties;
var A = Object.getOwnPropertyDescriptors;
var i = Object.getOwnPropertySymbols;
var _ = Object.prototype.hasOwnProperty, h = Object.prototype.propertyIsEnumerable;
var u = (a, s, o) => s in a ? k(a, s, { enumerable: !0, configurable: !0, writable: !0, value: o }) : a[s] = o, n = (a, s) => {
  for (var o in s || (s = {}))
    _.call(s, o) && u(a, o, s[o]);
  if (i)
    for (var o of i(s))
      h.call(s, o) && u(a, o, s[o]);
  return a;
}, l = (a, s) => q(a, A(s));
var d = (a, s) => {
  var o = {};
  for (var e in a)
    _.call(a, e) && s.indexOf(e) < 0 && (o[e] = a[e]);
  if (a != null && i)
    for (var e of i(a))
      s.indexOf(e) < 0 && h.call(a, e) && (o[e] = a[e]);
  return o;
};
import { jsxs as x, jsx as m } from "react/jsx-runtime";
import { forwardRef as p } from "react";
import { c as E } from "./get-size-Bc1Pz5yf.js";
import { c as F } from "./create-vars-resolver-Bzbn9G-G.js";
import { B as c, c as f, f as G, u as H, h as I } from "./factory-ueRxoNOV.js";
import { u as J } from "./use-styles-DToiHEa6.js";
var r = { root: "m_5ae2e3c", barsLoader: "m_7a2bd4cd", bar: "m_870bb79", "bars-loader-animation": "m_5d2b3b9d", dotsLoader: "m_4e3f22d7", dot: "m_870c4af", "loader-dots-animation": "m_aac34a1", ovalLoader: "m_b34414df", "oval-loader-animation": "m_f8e89c4b" };
const z = p((e, o) => {
  var t = e, { className: a } = t, s = d(t, ["className"]);
  return /* @__PURE__ */ x(c, l(n({ component: "span", className: f(r.barsLoader, a) }, s), { ref: o, children: [
    /* @__PURE__ */ m("span", { className: r.bar }),
    /* @__PURE__ */ m("span", { className: r.bar }),
    /* @__PURE__ */ m("span", { className: r.bar })
  ] }));
});
z.displayName = "@mantine/core/Bars";
const B = p((e, o) => {
  var t = e, { className: a } = t, s = d(t, ["className"]);
  return /* @__PURE__ */ x(c, l(n({ component: "span", className: f(r.dotsLoader, a) }, s), { ref: o, children: [
    /* @__PURE__ */ m("span", { className: r.dot }),
    /* @__PURE__ */ m("span", { className: r.dot }),
    /* @__PURE__ */ m("span", { className: r.dot })
  ] }));
});
B.displayName = "@mantine/core/Dots";
const g = p((e, o) => {
  var t = e, { className: a } = t, s = d(t, ["className"]);
  return /* @__PURE__ */ m(c, l(n({ component: "span", className: f(r.ovalLoader, a) }, s), { ref: o }));
});
g.displayName = "@mantine/core/Oval";
const R = {
  bars: z,
  oval: g,
  dots: B
}, K = {
  loaders: R,
  type: "oval"
}, M = F((a, { size: s, color: o }) => ({
  root: {
    "--loader-size": E(s, "loader-size"),
    "--loader-color": o ? I(o, a) : void 0
  }
})), b = G((a, s) => {
  const o = H("Loader", K, a), y = o, {
    size: e,
    color: t,
    type: S,
    vars: j,
    className: D,
    style: O,
    classNames: P,
    styles: w,
    unstyled: C,
    loaders: T,
    variant: V,
    children: N
  } = y, v = d(y, [
    "size",
    "color",
    "type",
    "vars",
    "className",
    "style",
    "classNames",
    "styles",
    "unstyled",
    "loaders",
    "variant",
    "children"
  ]), L = J({
    name: "Loader",
    props: o,
    classes: r,
    className: D,
    style: O,
    classNames: P,
    styles: w,
    unstyled: C,
    vars: j,
    varsResolver: M
  });
  return N ? /* @__PURE__ */ m(c, l(n(l(n({}, L("root")), { ref: s }), v), { children: N })) : /* @__PURE__ */ m(
    c,
    n(l(n({}, L("root")), {
      ref: s,
      component: T[S],
      variant: V,
      size: e
    }), v)
  );
});
b.defaultLoaders = R;
b.classes = r;
b.displayName = "@mantine/core/Loader";
export {
  b as L
};
